import React, { createContext, Dispatch, useContext, useReducer } from 'react';

import {
  ErrorContextActions,
  ErrorContextActionTypes,
  ErrorsProps,
  ErrorsProviderProps,
} from './ErrorContext.types';

const ErrorsContext = createContext<ErrorsProps | undefined>(undefined);
const ErrorsDispatchContext = createContext<Dispatch<ErrorContextActions> | undefined>(undefined);

const initialErrorsState: ErrorsProps = {
  error: undefined,
  count: undefined,
};

const ErrorsReducer = (state: ErrorsProps, action: ErrorContextActions) => {
  switch (action.type) {
    case ErrorContextActionTypes.SetError: {
      return {
        ...action.payload,
      };
    }
    case ErrorContextActionTypes.ClearError: {
      return {
        ...state,
        error: undefined,
        count: undefined,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action}`);
    }
  }
};

export const ErrorsContextProvider = ({ children }: ErrorsProviderProps) => {
  const [state, dispatch] = useReducer(ErrorsReducer, initialErrorsState);

  return (
    <ErrorsContext.Provider value={state}>
      <ErrorsDispatchContext.Provider value={dispatch}>{children}</ErrorsDispatchContext.Provider>
    </ErrorsContext.Provider>
  );
};

export const useErrorsState = () => {
  const context = useContext(ErrorsContext);

  if (context === undefined) {
    throw new Error('ErrorsState must be used within a ErrorsProvider');
  }

  return context;
};

export const useErrorsDispatch = () => {
  const context = useContext(ErrorsDispatchContext);

  if (context === undefined) {
    throw new Error('ErrorsDispatch must be used within a ErrorsProvider');
  }

  return context;
};
